module.exports = __webpack_public_path__ + "static/media/banner16.2745a241.jpg";